// @flow
import * as React from 'react'
import { type ComponentType } from 'react'
import tw from 'tailwind-styled-components'

// Is this really an atom?

type Props = {
  /** The content of the button */
  children: React.Node,
  /** The data-cy attribute for testing */
  dataCy?: string,
  /** The onClick handler */
  disabled?: boolean,
  /** The onClick handler */
  onClick?: Function,
}

const StyledButtonPill: ComponentType<Props> = tw.button`
  flex
  items-center
  border
  rounded
  px-1
  hover:bg-gray-200
  disabled:bg-gray-100
  disabled:opacity-50
 `

const StyledButtonPillText: ComponentType<Props> = tw.span`
  flex-1
  p-1
  text-center
  text-xs
  text-txt-emphasis
`

/** A pill-shaped button */
function ButtonPill({
  children,
  dataCy,
  onClick,
  disabled,
}: Props): React$Node {
  return (
    <StyledButtonPill data-cy={dataCy} disabled={disabled} onClick={onClick}>
      <StyledButtonPillText>{children}</StyledButtonPillText>
    </StyledButtonPill>
  )
}

export default ButtonPill
